export interface GroupParams {
    name: string
    locations: number[]

    sendAlarm: boolean
    sendAlarmDeactivated: boolean
    sendWarning: boolean
    sendWarningDeactivated: boolean

    // Alarm units
    cpuCard: boolean
    display: boolean
    printer: boolean
    paperStatus: boolean
    chipCardReader: boolean
    coinUnit: boolean
    door: boolean
    network: boolean
}

export interface Group {
    id: number
    name: string
    locations: number[]

    sendAlarm: boolean
    sendAlarmDeactivated: boolean
    sendWarning: boolean
    sendWarningDeactivated: boolean

    // Alarm units
    cpuCard: boolean
    display: boolean
    printer: boolean
    paperStatus: boolean
    chipCardReader: boolean
    coinUnit: boolean
    door: boolean
    network: boolean
}

export class Group implements Group {
    constructor(id: number = 0, name: string = "", locations: number[] = [], sendAlarm: boolean = false, sendAlarmDeactivated: boolean = false, sendWarning: boolean = false,
        sendWarningDeactivated: boolean = false, cpuCard: boolean = false, display: boolean = false, printer: boolean = false, paperStatus: boolean = false,
        chipCardReader: boolean = false, coinUnit: boolean = false, door: boolean = false, network: boolean = false
    ) {
        this.id = id
        this.name = name
        this.locations = locations
        this.sendAlarm = sendAlarm
        this.sendAlarmDeactivated = sendAlarmDeactivated
        this.sendWarning = sendWarning
        this.sendWarningDeactivated = sendWarningDeactivated
        this.cpuCard = cpuCard
        this.display = display
        this.printer = printer
        this.paperStatus = paperStatus
        this.chipCardReader = chipCardReader
        this.coinUnit = coinUnit
        this.door = door
        this.network = network
    }
}

export interface DutyTime {
    onDuty: boolean
    startHour: number
    startMinute: number
    startSeconds: number
    startMS: number
    endHour: number
    endMinute: number
    endSeconds: number
    endMS: number
}

export class DutyTime implements DutyTime {
    constructor(onDuty: boolean = false, startHour: number = 8, startMinute: number = 0, endHour: number = 17, endMinute: number = 0) {
        this.onDuty = onDuty
        this.startHour = startHour
        this.startMinute = startMinute
        this.startSeconds = 0
        this.startMS = 0
        this.endHour = endHour
        this.endMinute = endMinute
        this.endSeconds = 59
        this.endMS = 999
    }
}

export interface Duty {
    id: number

    personId: number // The ID of the person
    groupId: number // References a GroupData id, gives the details for the duty

    // These are the time for each day when the person is on duty. Each day can be undefined, if there is no duty that day
    mon: DutyTime
    tue: DutyTime
    wed: DutyTime
    thu: DutyTime
    fri: DutyTime
    sat: DutyTime
    sun: DutyTime
}

export class Duty implements Duty {
    constructor() {
        this.id = 0
        this.personId = 0
        this.groupId = 0
        this.mon = new DutyTime()
        this.tue = new DutyTime()
        this.wed = new DutyTime()
        this.thu = new DutyTime()
        this.fri = new DutyTime()
        this.sat = new DutyTime()
        this.sun = new DutyTime()
    }
}

export interface DutyParams {
    personId: number
    groupId: number
    mon: DutyTime
    tue: DutyTime
    wed: DutyTime
    thu: DutyTime
    fri: DutyTime
    sat: DutyTime
    sun: DutyTime
}
